// extracted by mini-css-extract-plugin
export var numsList = "style-module--nums-list--4a860";
export var res = "style-module--res--fda6a";